import { v4 } from 'uuid';

import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggle } from '@angular/material/slide-toggle';

import { ApmTranslatePipe } from '@mitsubishi/core';

import { FieldType, FieldTypeConfig, FormlyAttributes } from '@ngx-formly/core';

@Component({
  selector: 'apm-toggle-type',
  templateUrl: './toggle-type.component.html',
  styleUrls: ['./toggle-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatSlideToggle, NgClass, ReactiveFormsModule, FormlyAttributes, ApmTranslatePipe],
})
export class ToggleTypeComponent extends FieldType<FieldTypeConfig> {
  uuid = v4();
}
